var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.428C37.96 14.138 37.408 15.768 36.446 17C33.616 21.022 27.086 23.858 19.5 23.858C11.914 23.858 5.384 21.02 2.554 17C1.594 15.768 1.038 14.14 1 12.428C1 6.12 9.288 1 19.5 1C29.712 1 38 6.12 38 12.428Z",
    stroke: "#DB9B3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.428V21.572C38 27.88 29.712 33 19.5 33C9.288 33 1 27.88 1 21.572V12.428",
    stroke: "#DB9B3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCoin);
export default __webpack_public_path__ + "static/media/bankCoin.cb8965d0b5f0c151a9cdd55abd3e1952.svg";
export { ForwardRef as ReactComponent };